import './App.css';
import './firebase';
import * as React from 'react';
import {theme} from "./config/design/theme";
import { ThemeProvider } from '@mui/material/styles';
import {RouterProvider} from "react-router-dom";
import {router} from "./main/router";
import { SnackbarProvider,closeSnackbar } from 'notistack';
import {IconButton} from "@mui/material";
import axios from 'axios';
import {useEffect, useState} from "react";
import {defaultVariables} from "./config";
import {setStore} from "trim-redux";
import AppLoader from "./class/components/loaders/AppLoader";
import {loadSetting} from "./config/Security";
import {X} from "lucide-react";

axios.defaults.withCredentials = true;
axios.defaults.withXSRFToken = true;

function App() {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        async function run() {
            await loadData();
            setLoading(false); // Set loading to false after data is loaded
        }
        run();
    }, []);




    const loadData = async () => {
        // Check for app_token in query string
        const params = new URLSearchParams(window.location.search);
        const appToken = params.get('app_token');
        if (appToken) {
            await localStorage.setItem('ACT', appToken);
            await localStorage.setItem('from_app', 'true');
        }
        const loginToken = localStorage.getItem('ACT');

        if (loginToken) {
            const config = {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${loginToken}`
                }
            };
            await axios.get(`${defaultVariables.url}/auth/check-login`, config)
                .then(async response => {
                    await setStore({
                        isAuth: true,
                        user: response.data,
                    });
                    await loadSetting(); // Load settings after authentication
                })
                .catch(async error => {
                    console.log(error.response);
                    await setStore({
                        isAuth: false,
                        user: null,
                    });
                    await loadSetting();
                });
        } else {
            setStore({
                isAuth: false,
                user: null,
            });
            await loadSetting();
        }
    };

    // Render a loading indicator while data is loading

    return (
        <React.StrictMode>
            <ThemeProvider theme={theme}>
                <SnackbarProvider
                    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                    action={(snackbarId) => (
                        <IconButton onClick={() => closeSnackbar(snackbarId)}>
                            <X className="lucide-icon"/>
                        </IconButton>
                    )}
                >
                    {!loading ? <RouterProvider router={router} /> : null}
                    {loading ? (
                        <div
                            style={{
                                position: "fixed",
                                inset: 0,
                                zIndex: 200000,
                                backgroundColor: "rgba(255,255,255,0.96)",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                            }}
                        >
                            <AppLoader />
                        </div>
                    ) : null}
                </SnackbarProvider>
            </ThemeProvider>
        </React.StrictMode>
    );
}

export default App;
